import React, { Component } from 'react'
import Axios from 'axios'
import { getUser } from '../../actions/session'
import CustomLoader from '../common/loader'
import CarrierEdit from './carrierEdit'
import CustomModal from '../common/modal'
import { Notifications } from '../common/notification'
import Switch from "react-switch";
import { CARRIER_DASHBOARD_API, CARRIER_LISTING, CARRIER_RATEDECK_DOWNLOAD, CARRIER_TOGGAL, LOGIN_URL } from '../../config/rest_endpoints'
import { RC_LOAD_LOGIN, CARRIER_INFO } from '../routers/RouteConstants'
import { withRouter, Link } from 'react-router-dom'
import CarrierAdd from './carrierAdd'
import Select from 'react-select';
import componentTabs from './componentTabs'
import Pagination from "react-js-pagination";


class CarrierTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            carrierTable: [],
            isGetting: false,
            isEditModal: false,
            editData: [],
            updateMsg: '',
            isAddModal:false,
            //pagination state
            activePage: 1,
            itemsCount: 9,
            totalCount: null,
            name:'',
            tableData:[],
            searchValue:'',
            isView:false,
            viewData:[],
            filterStatus : { label: 'All', value: 'all' },
            countList : [
                { label: 'All', value: 'all' },
                { label: 'Active', value: true },
                { label: 'In active', value: false },
                
            ]
        }
        this.openEditModal = this.openEditModal.bind(this)
        this.closeAddModal = this.closeAddModal.bind(this)
        this.openAddModal = this.openAddModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.getCarrierData = this.getCarrierData.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.getTable = this.getTable.bind(this)
        this.searchSpace = this.searchSpace.bind(this)
        this.openViewModal = this.openViewModal.bind(this)
        this.closeViewModal = this.closeViewModal.bind(this)

    }

    openEditModal(row) {
        this.setState({
            isEditModal: true,
            editData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false,
        })
    }

    openViewModal(row) {
        this.setState({
            isView: true,
            viewData: row.carrierCodes,
            editData: row
        })
    }

    closeViewModal() {
        this.setState({
            isView: false,
        })
    }

    openAddModal() {
        this.setState({
           isAddModal:true
        })
    }

    closeAddModal() {
        this.setState({
            isAddModal:false
         })
    }

    searchSpace(e) {
        this.setState({ searchValue: e.target.value })
    }

    componentDidMount() {
        // this.getCarrierData()
        this.getTable()
        // this.renderCarrierTable()

    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.getCarrierData()
        });
    }

    getCarrierData() {
        const { User, activePage, itemsCount } = this.state
        this.setState({
            isGetting: true
        })
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${CARRIER_LISTING}?page=${activePage}&limit=${itemsCount}`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                var resp = res.data.data.carriers
                console.log('object :>> ', resp);
                let carrierTable = Object.keys(resp).map(i => {
                    return resp[i]
                })
                this.setState({
                    carrierTable,
                    isGetting: false,
                    totalCount:res.data.pageinfo.totalCount
                })
            } else {

            }
        }).catch(err => {
            Notifications.notify(err, "Failed", "error");
            this.setState({isGetting:false})
            // var logs = err.response
            // console.log('logs :>> ', logs);
            // if (logs === 401) {
            //     localStorage.removeItem('user');
            //     this.props.history.push(RC_LOAD_LOGIN);
            // }
        })
    }

    toggleSwitch(row) {
        const { User } = this.state
        const data = {
            "carrierid": row.carrierid,
            "concurrentcalls": row.concurrentcalls,
            "cps": row.cps,
            "status": !row.status
        }
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.put(`${CARRIER_TOGGAL}/5e95f6520d5cf5616da77968/${row.name}/changeCarrierStatus`, data, { headers }).then(res => {
            if (res) {
                this.setState({
                    updateMsg: res.data.message
                })
                this.getCarrierData()
                Notifications.notify(this.state.updateMsg, "Success", "success");
            }
            else {
                Notifications.notify("error failed", "Failed", "error");
            }
        })

    }

    onRedirecting(data) {
        var id = data.id
        var Name = data.carrierName
        console.log('Name :>> ', Name);
        this.setState({name:Name})
        this.props.history.push(`${CARRIER_INFO}/${id}/${Name}`)
    }

    handleSelectChange = (selectedOption) => {
        this.setState({ filterStatus: selectedOption },() => {
            this.getTable()
            console.log("filterStatus", this.state.filterStatus)
        });
      };

    getTable() {
        const {User,filterStatus} = this.state
        console.log('filterStatus', filterStatus)
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${CARRIER_DASHBOARD_API}`,{headers}).then(res=>{
            if(res) {
                const all = res.data.data
                console.log('all', all)
                const activeAccount = all.filter(item => item.active === true)
                const inactiveAccount = all.filter(item => item.active === false)

                console.log('inactiveAccount', inactiveAccount)
                const resp = filterStatus.value === 'all' ? all : filterStatus.value  ? activeAccount : inactiveAccount || []

                console.log(`resp`, resp)
                this.setState({
                    tableData:resp,
                    isGetting:false
                })
            }
        }).catch(err=>{
            const alert = err.response
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(RC_LOAD_LOGIN)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message,"Failed",'error')
            this.setState({
                isGetting:false
            })
        })
    }

    handleDownload(id) {
        const {User} = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${CARRIER_RATEDECK_DOWNLOAD}?file=${id}`,{headers}).then(res=>{
            let content = res.headers['content-disposition']
            if(res) {
                var resp = res.data
                var short = content.split("filename=")[1]
                var filename = short.replace(/['"]+/g, '')
                const url = window.URL.createObjectURL(new Blob([resp])) 
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${filename}.csv`)
                document.body.appendChild(link)
                link.click()
            }
        }).catch(err=>{
            const alert = err.response
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
        })
    }

    __renderAccountTable() {
        const { tableData,searchValue } = this.state
        const disableStyle = {
            backgroundColor: 'lightgray'
        }
        const normalStyle = {
            backgroundColor: 'white'
        }
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (!tableData.length) {
            return nullData
        }
        else {
            return tableData.filter(table => {
                if (searchValue === null) {
                    return table
                }
                else if (table.carrierName.toLowerCase().includes(searchValue.toLowerCase())) {
                    return table
                }
            }).map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}} onClick={this.onRedirecting.bind(this, row)}> 
                        <Link>
                            <span className={row.active === true ? 'text-success' : row.active === false ? 'text-danger' : ''}>{row.carrierName}</span>
                        </Link>
                        </td>
                        <td style={{textAlign:'center'}}>{row.minutes}</td>
                        <td style={{textAlign:'center'}}>{row.spent}</td>
                        <td style={{textAlign:'center'}}>{row.sessions}</td>
                        <td style={{textAlign:'center'}}>{row.sessionsPCT}</td>
                        <td style={{textAlign:'center'}}>{row.CPS}</td>
                        <td style={{textAlign:'center'}}>{row.CPSPCT}</td>
                        <td style={{textAlign:'center'}}>{row.ASR}</td>
                        <td style={{textAlign:'center'}}>{row.ACD}</td>
                        <td style={{textAlign:'center'}}>{row.SDP}</td>
                        <td style={{textAlign:'center'}}>{row.yesterdaySpent}</td>
                        {/* <td style={{textAlign:'center'}}>
                        <i onClick={this.openViewModal.bind(this,row)} class="edit-button fa fa-regular fa-eye"></i>
                        </td> */}
                        <td style={{textAlign:'center'}}>{row.active ? <span class="badge badge-success">True</span> :<span class="badge badge-danger">False</span>}</td>
                        <td style={{textAlign:'center'}}>{row.ratedeck.includes('csv') ? <Link onClick={this.handleDownload.bind(this, row.ratedeckID)}>{row.ratedeck === '' ? 'N/A' : row.ratedeck}</Link> : row.ratedeck === '' ? 'N/A' : row.ratedeck }</td>
                        {/* <td>{row.profit}</td>
                        <td>{row.rate}</td> */}
                        {/* <td>{row.active === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                        <td><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td> */}
                    </tr>
                )
            })
        }

    }

    renderViewData() {
        const {viewData} = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (!viewData.length) {
            return nullData
        }
        else {
            return viewData.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.reason}</td>
                        <td style={{textAlign:'center'}}>{row.code}</td>
                        <td style={{textAlign:'center'}}>{row.count}</td>
                    </tr>
                )
            })
        }
    }

  
    returnTotal() {
        const {tableData} = this.state
        let totalMin = []
        let totalSpent = [] 
        let totalSession = []
        let totalSessionPCT = []
        let totalCPS = [] 
        let totalCPSPct = [] 
        let totalASR = [] 
        let totalACD = [] 
        let totalSDP = []
        
        if(tableData.length>1) {
             tableData.forEach((item) => {
                 totalMin.push(item['minutes'])
                 totalSpent.push(item['spent'])
                 totalSession.push(item['sessions'])
                 totalSessionPCT.push(item['sessionsPCT'])
                 totalCPS.push(item['CPS'])
                 totalCPSPct.push(item['CPSPCT'])
                 totalASR.push(item['ASR'])
                 totalACD.push(item['ACD'])
                 totalSDP.push(item['SDP'])
                // const totalMin.push(item['minutes'])
            })
            return (
                <tr >
                    <td> Total</td>
                    <td> {totalMin.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalSpent.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalSession.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalSessionPCT.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalCPS.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalCPSPct.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalASR.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalACD.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td> {totalSDP.reduce((a,b) => a + b).toFixed(4)}</td>
                    <td></td>
                    <td> </td>
                    <td> </td>
                    {/* <td> N/A</td>
                    <td> N/A</td> */}
                </tr>
            )
           
        }
        
    }

    // renderCarrierTable() {
    //     const { carrierTable } = this.state
    //     if(carrierTable === null || carrierTable === undefined || carrierTable.length === 0) {
    //         return (
    //             <div className="ml-4 mt-2">
    //                 <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
    //                 <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
    //             </div>
    //         )
    //     }
    //     else {
    //         return carrierTable.map((row, idx) => {
    //             return (
    //                 <tr key={idx}>
    //                     <td onClick={this.onRedirecting.bind(this, row)}><Link>{row['name']}</Link></td>
    //                     {/* <td>{row.carrierID}</td> */}
    //                     <td>{row['cps']}</td>
    //                     <td>{row.sessions}</td>
    //                     <td>{row['prefix'] == '' ? 'N/A' : row['prefix']}</td>
    //                      <td>{row.holdTime == ''? 'N/A' : row.holdTime }</td>
    //                     <td>{row.status === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
    //                     {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row)} checked={row.status} /></span></td> */}
    //                     <td><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td>
    //                 </tr>
    //             )
    //         })
    //     }
    // }

    render() {
        const { isGetting, isEditModal, editData,isAddModal, tableData, totalCount,isView } = this.state
        console.log('123',totalCount)
        let editCarrierModal = {
            details: {
                info: `Edit ${editData.name}`,
                msg: <CarrierEdit close={this.closeEditModal} previousData={editData} carrierListing={this.getTable} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }
        let addCarrierModal = {
            details: {
                info: `Add Carrier`,
                msg: <CarrierAdd close={this.closeAddModal}  carrierListing={this.getTable} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeAddModal },
            cancelBtn: { label: "Cancel", action: this.closeAddModal }
        }
        let viewModal = {
            details: {
                info: `${editData.carrierName}`,
                msg: (
                    <div className="datatable-scroll " style={{ overflowX: 'auto', overflowY: 'auto' }}>
                        <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped table-bordered no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                            <thead>
                                <tr className="stickeyHeader">
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Reason</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Code</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderViewData()}
                            </tbody>
                        </table>
                    </div>
                )
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeViewModal },
            cancelBtn: { label: "Cancel", action: this.closeViewModal }
        }

        return (
            <div>
                <CustomModal
                    visibility={isEditModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={editCarrierModal.details}
                    showBtns={false}
                    cancelBtn={editCarrierModal.cancelBtn}
                    crossBtn={editCarrierModal.crossBtn}
                />
                 <CustomModal
                    visibility={isAddModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addCarrierModal.details}
                    showBtns={false}
                    cancelBtn={addCarrierModal.cancelBtn}
                    crossBtn={addCarrierModal.crossBtn}
                />
                 <CustomModal
                    visibility={isView}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={viewModal.details}
                    showBtns={false}
                    cancelBtn={viewModal.cancelBtn}
                    crossBtn={viewModal.crossBtn}
                />
                  <div className='row'>
                        <div className='col-md-3 offset-md-9'>
                        <button type="submit" className="btn btn-success btn-sm ml-3 mb-3 float-right main-button" onClick={this.openAddModal}>Add Carrier <i className="fas fa-plus ml-2"></i></button>
                        </div>
                </div>
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                    <div id="DataTables_Table_0_wrapper" className="no-footer">
                        <div className="datatable-header border-0 row">
                            <div id="DataTables_Table_0_filter" className="col-md-6 col-sm-6 col-lg-4 dataTables_filter">
                                {/* <label><span>Filter:</span>
                            <input type="search" className="" placeholder="Type to filter..." value={this.state.searchValue} onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                        </label> */}
                                <div class="input-group">
                                    <input type="text" class="form-control border-right-0" onChange={this.searchSpace}  placeholder="Filter Carrier" />

                                    <span class="input-group-append">
                                        <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                    </span>
                                </div>
                            </div>
                            {/* col 6 */}
                            <div className="col-md-3 col-sm-3 col-lg-3 offset-lg-5  justify-content-end header-elements">
                            <Select
                                value={this.state.filterStatus}
                                onChange={this.handleSelectChange}
                                options={this.state.countList}
                                placeholder="Select status..."
                            />
                            </div>
                            {/* col 6 */}
                        </div>
                        
                        <div className="datatable-scroll" style={{ overflowX: 'auto',overflowY: 'auto', maxHeight:'56em' }}>
                            <table className="table-style table table-striped dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                <tr className="stickeyHeader table-heading-style">
                                        <th>Carrier Name</th>
                                        <th>Minutes</th>
                                        <th>Spent</th>
                                        <th>Sessions</th>
                                        <th>Sessions %</th>
                                        <th>CPS</th>
                                        <th>CPS %</th>
                                        <th>ASR</th>
                                        <th>ACD</th>
                                        <th>SDP</th>
                                        <th>Spent Yesterday</th>
                                        {/* <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Carrier Code</th> */}
                                        <th>Active</th>
                                        <th>Current Domestic Deck</th>
                                        {/* <th>Profit</th>
                                        <th>Rate</th> */}
                                    </tr>
                                    {/* <tr className="bg-dark">
                                        <th>Name</th>
                                        <th>CPS</th>
                                        <th>Sessions</th>
                                        <th>Prefix</th>
                                        <th>Hold TIme</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr> */}
                                </thead>
                                <tbody>
                                    {/* {isGetting ? <CustomLoader /> : this.renderCarrierTable()} */}
                                    {isGetting ? <CustomLoader /> : this.__renderAccountTable()}
                                    {tableData.length > 0 ? this.returnTotal() : ''}


                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer mt-1">
                           {totalCount >= 9 ?  
                           <div className="mt-3">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={itemsCount}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div> :''}

                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(CarrierTable)